/* eslint-disable react/jsx-one-expression-per-line */
import { FileOpenRounded, ErrorOutline } from '@mui/icons-material'
import classNames from 'classnames'
import { stateCurrentAppeal } from 'feature/appeals/redux/appealFormCreateSelector'
import { convertDataToStringWithMonth } from 'helpers/date/convertDataToStringWithMonth'
import { getTimeByTimeZone } from 'helpers/date/getTimeByTimeZone'
import { isMoscowTimeZone } from 'helpers/date/isMoscowTimeZone'
import { useAppSelector } from 'store/hooks'
import { Button } from 'ui'
import { LoaderInCentalPosition } from 'widget'
import { DesktopMobileTooltip } from 'widget/DesktopMobileTooltip/DesktopMobileTooltip'

import { OfferDatesBlock } from '../OfferDatesBlock/OfferDatesBlock'
import { OfferPaymentApprovedInf } from '../OfferPaymentApprovedInf/OfferPaymentApprovedInf'
import style from '../OfferPaymentDefault/OfferPaymentDefault.module.scss'
import { TOfferPayment } from '../types'
import { useOfferPriceBlock } from '../OfferPriceBlock/useOfferPriceBlock'

// информация об оплате КП в статусе "Approved"

export function OfferPaymentApproved({
  offer,
  hasPaidOrder,
  recalcInProgress,
  recalculateHandler,
  isOfferRecalcLoading,
}: TOfferPayment) {
  const { checkUrl, contractUrl, price, acquiringUrl, offerUrl, id } = offer
  const { editAppealLoading, appealStatus } = useAppSelector(stateCurrentAppeal)

  const payDate = getTimeByTimeZone(offer.payDate)
  const isAppealOffersLoading = editAppealLoading.appealOffers

  const { stage, createdDate, expireDate, isOfferActive, isDeclined } =
    useOfferPriceBlock(offer, appealStatus, 'APPROVED')

  // для одобренного КП блок оплаты почти всегда виден: скрыт только когда
  // нет ни активного срока, ни созданной даты, ни ссылок на КП/оплату
  const isApprovedPaymentInfoVisible =
    isOfferActive || (createdDate && !hasPaidOrder) || offerUrl || acquiringUrl

  // в статусе WAITING_DEALER заказ уже выбрал КП, но оплата ещё недоступна:
  // пользователь видит только информацию о заказе, без заголовка и кнопки оплаты
  const isWaitingDealer = appealStatus === 'WAITING_DEALER'

  return (
    <div className={style.payment}>
      {!isWaitingDealer && <span className='h2'>Оплата</span>}

      {isAppealOffersLoading && <LoaderInCentalPosition />}
      <div
        className={classNames(
          style.paymentInf,
          isAppealOffersLoading ? style.hidden : '',
        )}
      >
        {offer?.checkUrl && (
          <Button
            // @ts-ignore
            to={checkUrl}
            startIcon={<FileOpenRounded color='primary' />}
            variant='contained'
            color='secondary'
            className={classNames(style.openCheck, style.openCheckPaid)}
            data-testid='offer-check-btn'
          >
            Открыть чек
          </Button>
        )}

        {payDate && (
          <span className={style.paidDate}>
            Оплачено {convertDataToStringWithMonth(payDate, true)}
            {!isMoscowTimeZone() && (
              <DesktopMobileTooltip
                title='По местному времени'
                Icon={<ErrorOutline />}
              />
            )}
          </span>
        )}

        {contractUrl && (
          <div
            className={classNames(
              style.document,
              isWaitingDealer ? style.documentNoTitle : '',
            )}
          >
            <span>Договор оферты</span>
            <span className={style.document__description}>
              Оплачивая, Вы соглашаетесь с договором-офертой
            </span>
            <Button
              // @ts-ignore
              to={contractUrl}
              startIcon={<FileOpenRounded color='primary' />}
              variant='contained'
              color='secondary'
              className={style.openCheck}
              download
              data-testid='offer-contract-btn'
            >
              Договор оферты
            </Button>
          </div>
        )}

        {isApprovedPaymentInfoVisible && (
          <div className={style.paymentInf}>
            {createdDate && !hasPaidOrder && (
              <OfferDatesBlock
                createdDate={createdDate}
                expireDate={expireDate}
                isOfferActive={isOfferActive}
                stage={stage}
              />
            )}
            {isOfferRecalcLoading && (
              <LoaderInCentalPosition className={style.recalcLoader} />
            )}

            {!isOfferRecalcLoading && (
              <OfferPaymentApprovedInf
                offer={offer}
                isOfferActive={isOfferActive}
                recalculateHandler={() => recalculateHandler(id)}
                isPaymentBlockActive={
                  !!acquiringUrl?.length &&
                  !hasPaidOrder &&
                  price > 0 &&
                  !isDeclined &&
                  !isWaitingDealer
                }
                recalcInProgress={recalcInProgress}
                appealStatus={appealStatus}
              />
            )}
          </div>
        )}
      </div>
    </div>
  )
}
